export enum MarketingItemLayout {
  CTA_LEFT = 'LEFT',
  CTA_RIGHT = 'RIGHT',
  TRENDING_LEFT = 'TRENDING_LEFT',
  TRENDING_RIGHT = 'TRENDING_RIGHT',
  EMAIL_CENTERED = 'EMAIL_CENTERED',
  EMAIL_LEFT = 'EMAIL_LEFT',
  EMAIL_RIGHT = 'EMAIL_RIGHT',
  MULTIPLE_CONTENT_LANDSCAPE = 'MULTIPLE_CONTENT_LANDSCAPE',
  MULTIPLE_CONTENT_PORTRAIT = 'MULTIPLE_CONTENT_PORTRAIT',
  DETAILED_PAGE_BANNER_LEFT = 'DETAILED_PAGE_BANNER_LEFT',
  DETAILED_PAGE_BANNER_CENTER = 'DETAILED_PAGE_BANNER_CENTER',
  DETAILED_PAGE_BANNER_RIGHT = 'DETAILED_PAGE_BANNER_RIGHT',
}

export enum MarketingButtonAction {
  SIGN_IN = 'SignIn',
  SIGN_UP = 'SignUp',
  CHOOSE_NEW_PASSWORD = 'ChooseNewPassword',
  INTERNAL_PAGE = 'InternalPage',
  PROGRAM = 'Program',
  EXTERNAL_URL = 'ExternalURL',
  RENEW_OR_COMPLETE_SUBSCRIPTION = 'RenewOrCompleteSubscription',
}
